import { render, staticRenderFns } from "./LgFinderPageMarca.vue?vue&type=template&id=96285204"
import script from "./LgFinderPageMarca.vue?vue&type=script&lang=js"
export * from "./LgFinderPageMarca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports